/**
 * Parallax constants and selectors (omega-parallax.js v3, 2026-08-24, L59–130;
 * docs/behavior/hero-and-motion.md §6.2). Copied, not re-derived.
 */
export const PARALLAX_VERSION = 'omega-parallax-2026-08-24-v3';

/** Displacement ratios, as a fraction of the scroll span. */
export const D_IMG = 0.22;
export const D_BLOCK = 0.07;
export const D_CARD = 0.055;
export const D_HEAD = 0.05;

/** Hard ceilings (px). Measured slack usually binds first. */
export const CAP_PAN = 64;
export const CROP_K = 0.85;
export const CAP_BLOCK = 26;
export const CAP_CARD = 22;
export const CAP_HEAD = 16;
export const CAP_LOOSE = 14;
export const SLACK_K = 0.35;
/** px needed next to a reveal-animated element. */
export const MIN_GAP = 40;
/** px needed where nothing else is animating. */
export const MIN_GAP_PLAIN = 12;
/** Handheld taper under `(max-width: 768px)`. */
export const MOBILE_K = 0.62;

/** Registration thresholds (px). */
export const MIN_IMAGE_SIDE = 90;
export const MIN_BLOCK_HEIGHT = 40;
export const MIN_CARD_HEIGHT = 80;
export const HEAD_HEIGHT_RANGE = [16, 520] as const;
/** Minimum crop (px) that makes an image a pan layer. */
export const MIN_CROP = 8;
/** Distance beyond the viewport (px) within which a layer stays live. */
export const LIVE_MARGIN = 240;
/** Gap reported when an element has no neighbour up to the root. */
export const ROOT_GAP = 240;

export const SCAN_DEBOUNCE_MS = 120;
export const MEASURE_DEBOUNCE_MS = 150;
export const BOOT_SCANS_MS = [400, 1200, 2400] as const;
export const BOOT_MEASURE_MS = 3200;

export const GATE_SEL = '#gate,.gate,.gate__card,.gate-inner,[data-omega-gate]';
export const HOLD_SEL = '.hero,.nav,.footer,.cart-drawer,.modal-overlay,.toast,.omega-rung-row,.app-loader,.top__row';
export const GRID_SEL = [
  '.product-grid',
  '.collection-grid',
  '.funnel-days-grid',
  '.tool-grid',
  '.journal-grid',
  '.sci-start-here__grid',
  '.scientia-pillars-wrapper',
  '.mission-pillars',
  '.funnel-benefits',
  '.wall',
  '.sci-pillars__tabs',
].join(',');
export const BLOCK_SEL = [
  '.section__header',
  '.newsletter__content',
  '.newsletter__form-wrapper',
  '.funnel-motto',
  '.funnel-closing',
  '.funnel-capture__header',
  '.funnel-inline-quote',
  '.funnel-scroll-indicator',
  '.mission-statement',
  '.mission-golden',
  '.mission-omega',
  '.scientia-phi',
  '.scientia-why',
  '.sci-philosophy__bridge',
  '.scientia-closing',
  '.sci-footer-cta__inner',
  '.sci-deep-dives',
  '.collection-header',
  '.contact-info',
  '.contact-form',
  '.arcana-symbol',
  '.kybalion-intro',
  '.dash-hero',
  '.lesson-header',
  '.sec__head',
  '.self',
  '.creed',
  '.band',
].join(',');
export const HEAD_SEL = [
  '.section__title',
  '.section__subtitle',
  '.collection-header__title',
  '.collection-header__subtitle',
  '.funnel-hero__badge',
  '.funnel-hero__subtitle',
  '.funnel-features__title',
  '.scientia-hero__title',
  '.scientia-hero__quote',
  '.mission-golden__number',
  '.sec__t',
  '.sec__n',
].join(',');
/** Elements another library animates on reveal; they and their neighbours need MIN_GAP. */
export const REVEAL_SEL =
  '[data-om-reveal],.section__title,.section__subtitle,.section__header,.product-grid .product-card,.glass-card,.video-player,.btn,.funnel-feature';
